import { styled } from "baseui";

export const CenteredWrapper = styled("div", () => ({
  display: "flex",
  flexDirection: "row",
  alignItems: "center",
}));
